import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = [
  {
    path: '/widgets/tables',
    exact: true,
    page: getLoadablePage(() => import(/* webpackChunkName: "tables" */ '../pages/tables/tables')),
    chunkName: 'tables',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/most-popular-cars',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "most-popular-cars" */ '../pages/most-popular-cars/most-popular-cars')
    ),
    chunkName: 'most-popular-cars',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/depreciation',
    exact: true,
    // eslint-disable-next-line venom/no-malformed-magic-comment
    page: getLoadablePage(() => import(/* webpackChunkName: "deprecation" */ '../pages/depreciation/depreciation')),
    chunkName: 'depreciation',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/most-sold-type',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "most-sold-type" */ '../pages/most-sold-type/most-sold-type')
    ),
    chunkName: 'most-sold-type',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/most-sold-type/table',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "most-sold-type" */ '../pages/most-sold-type/most-sold-type-table')
    ),
    chunkName: 'most-sold-type',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/most-popular-car-colors',
    exact: true,
    page: getLoadablePage(
      () =>
        import(
          /* webpackChunkName: "most-popular-car-colors" */ '../pages/most-popular-car-colors/most-popular-car-colors'
        )
    ),
    chunkName: 'most-popular-car-colors',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/car-loan-apr-interest-rate',
    exact: true,
    page: getLoadablePage(
      () =>
        import(
          /* webpackChunkName: "car-loan-apr-interest-rate" */ '../pages/car-loan-apr-interest-rate/car-loan-apr-interest-rate'
        )
    ),
    chunkName: 'car-loan-apr-interest-rate',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/vehicle',
    exact: true,
    page: getLoadablePage(() => import(/* webpackChunkName: "vehicle-widgets" */ '../pages/vehicle/vehicle')),
    chunkName: 'vehicle-widgets',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
  {
    path: '/widgets/ev-range-leaderboard',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "ev-range-leaderboard" */ '../pages/ev-range-leaderboard/ev-range-leaderboard')
    ),
    chunkName: 'ev-range-leaderboard',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
    enableLooseEtag: true,
  },
  {
    path: '/widgets/u-drags-leaderboard',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "u-drags-leaderboard" */ '../pages/u-drags-leaderboard/u-drags-leaderboard')
    ),
    chunkName: 'u-drags-leaderboard',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
    enableLooseEtag: true,
  },
  {
    path: '/widgets/fast-charging-leaderboard',
    exact: true,
    page: getLoadablePage(
      () =>
        import(
          /* webpackChunkName: "fast-charging-leaderboard" */ '../pages/fast-charging-leaderboard/fast-charging-leaderboard'
        )
    ),
    chunkName: 'fast-charging-leaderboard',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
    enableLooseEtag: true,
  },
  {
    path: '/widgets/self-driving-cars',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "self-driving-cars" */ '../pages/self-driving-cars/self-driving-cars')
    ),
    chunkName: 'self-driving-cars',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
    enableLooseEtag: true,
  },
  {
    path: '/widgets/leaderboard/:leaderboardId',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "leaderboard" */ '../pages/leaderboard/leaderboard-definition')
    ),
    chunkName: 'leaderboard',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
    enableLooseEtag: true,
  },
  {
    path: '/widgets/car-payments',
    exact: true,
    page: getLoadablePage(() => import(/* webpackChunkName: "car-payments" */ '../pages/car-payments/car-payments')),
    chunkName: 'car-payments',
    resolveLocationInParallelToPagePreload: true,
    removeCsp: true,
  },
];
